module.exports = __webpack_public_path__ + "img/piccolos.6148cd2b.jpg";